import React, { useState } from "react";
import helpicon from "../../images/helpicon.svg";
import { GoPlus } from "react-icons/go";
import { FaCheck } from "react-icons/fa6";
import { Checkbox } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import AISearchAndSet from "./AISearchAndSet";
import { useAppSelector } from "hooks/reduxHooks";
const GoPlusSin = GoPlus as unknown as React.FC as any;
const FaCheckSin = FaCheck as unknown as React.FC as any;

interface Tab {
  id: string;
  label: string;
}
interface data {
  label: string;
  example?: string;
  subLabel?: string;
  nav: string;
}

interface FiltersSidebarProps {
  activeTab: string;
  title?: string;
  setActiveTab: (tabId: string) => void;
  data: data[];
  marginStart?: boolean;
  AIAssistant?: boolean;
  reqTabs?: boolean;
}

const FiltersSidebar: React.FC<FiltersSidebarProps> = ({
  activeTab,
  setActiveTab,
  data,
  marginStart = true,
  AIAssistant = true,
  reqTabs = true,
  title = "AI Assistant",
}) => {
  const tabs: Tab[] = [
    { id: "Filters", label: "Filters" },
    // { id: "addfilters", label: "+ Add Filter" },
  ];

  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [filterIndex, setFilterIndex] = useState<number | null>(1);
  const defaultSelectedProject = useAppSelector((state) => state.search.selectedProject);

  const handleItemClick = (index: number, nav: string) => {
    setActiveIndex(index === activeIndex ? null : index);
    const element = document.getElementById(nav);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const filterItemClick = (index: number) => {
    setFilterIndex(index === filterIndex ? null : index);
  };
  const allAddJobTitle = useSelector((state: RootState) => state.search.job_titles);
  const keywords = useSelector((state: RootState) => state.search.keywords);
  const skills = useSelector((state: RootState) => state.search.skills);
  const work_experiences = useSelector((state: RootState) => state.search.work_experiences);
  const industryType = useSelector((state: RootState) => state.search.industry_type);
  const industryLeaders = useSelector((state: RootState) => state.search.industry_leaders);
  const segments = useSelector((state: RootState) => state.search.segments);
  const includeCompany = useSelector((state: RootState) => state.search.company);
  const excludeCompany = useSelector((state: RootState) => state.search.exclude_company);
  const includeLocation = useSelector((state: RootState) => state.search.locations);
  const excludeLocation = useSelector((state: RootState) => state.search.exclude_locations);
  const degree = useSelector((state: RootState) => state.search.education_fields);
  const university = useSelector((state: RootState) => state.search.universities);
  const searchName = useSelector((state: RootState) => state.search.search_name);
  const min_exp = useSelector((state: RootState) => state.search.min_exp);
  const max_exp = useSelector((state: RootState) => state.search.max_exp);

  const listOfSteps = [
    {
      title: "project",
      status: defaultSelectedProject ? true : false,
    },
    {
      title: "title",
      status: searchName?.length > 0 ? true : false,
    },
    {
      title: "job_titles",
      status: allAddJobTitle?.length > 0 ? true : false,
    },
    {
      title: "keywords",
      status: keywords?.length > 0 ? true : false,
    },
    // {
    //   title: "skills",
    //   status: skills?.length > 0 ? true : false,
    // },
    {
      title: "work_experiences",
      status: min_exp > 0 || max_exp != 35 ? true : false,
    },
    {
      title: "locations",
      status: includeLocation.length > 0 || excludeLocation.length > 0 ? true : false,
    },
    {
      title: "education",
      status: degree.length > 0 && university.length > 0 ? true : false,
    },
  ];

  // useEffect(() => {
  //   searchConfigGenerator()
  // }, [AIQuery])

  return (
    <div className={`w-[230px] bg-white border-r border-main-border h-[75vh]`}>
      {/* {reqTabs && (
        // <div className="border-b border-gray-200 dark:border-gray-700">
        <div className="border-b border-gray-200">
          <ul
            className="flex flex-wrap -mb-px text-sm font-medium text-center justify-around"
            role="tablist"
          >
            {tabs.map((tab) => (
              <li className="me-2" role="presentation" key={tab.id}>
                <button
                  className={`inline-block p-4 border-b-2 capitalize  rounded-t-lg ${
                    activeTab === tab.id
                      ? "text-primary border-primary dark:text-primary dark:border-primary font-semibold"
                      : "text-text-quaternary border-gray-100 hover:text-primary hover:border-primary dark:text-primary dark:border-transparent dark:hover:text-primary dark:hover:border-primary"
                  }`}
                  onClick={() => setActiveTab(tab.id)}
                  role="tab"
                  aria-controls={tab.id}
                  aria-selected={activeTab === tab.id}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )} */}

      <div className="overflow-auto custom-scrollbar h-[75vh]">
        {activeTab === "Filters" && (
          <div className="py-4 pr-4">
            {/* <div>
              <label className="text-text-secondary font-medium text-sm flex items-center">
                {title}
                <span className="text-primary">*</span>
                <div className="relative group">
                  <img src={helpicon} alt="Help Icon" className="ps-1 cursor-pointer" />
                  <div className="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 hidden group-hover:block p-2 bg-tooltip-bg text-white text-xs rounded whitespace-nowrap shadow-lg">
                    This is a tooltip
                  </div>
                </div>
              </label>
              {AIAssistant && (
                <>
                  <AISearchAndSet />
                </>
              )}
            </div> */}

            <ul>
              {data.map((item, index) => {
                const step = listOfSteps.find((step) => step.title === item.nav);
                const isActive = step?.status ?? false;

                return (
                  <li
                    key={index}
                    className={`pb-4 pt-4 px-3 border-b border-main-border rounded cursor-pointer ${
                      activeIndex === index ? "bg-utility-bluelight" : ""
                    } ${isActive ? "bg-green-50" : ""}`}
                    onClick={() => handleItemClick(index, item.nav)}
                  >
                    <div className="flex gap-3 items-center">
                      <div
                        style={{ minWidth: 40, minHeight: 40, aspectRatio: 1 }}
                        className={`rounded-full overflow-hidden border flex items-center justify-center ${
                          activeIndex === index
                            ? "bg-[#F4EBFF] border-solid border-[#D6BBFB] text-primary"
                            : "border-dashed border-primary-border text-text-heading"
                        } ${
                          isActive
                            ? "bg-success-secondary border-solid border-success-secondary"
                            : "border-dashed border-primary-border text-text-heading"
                        }`}
                      >
                        {isActive ? <FaCheckSin className="text-white" /> : <GoPlusSin />}
                      </div>
                      <div>
                        <p className="text-text-secondary text-sm font-semibold capitalize">
                          {item.label}
                        </p>
                        {item.example && (
                          <p className="text-sm font-normal ellipsis-1-lines">
                            <span>ex:</span> {item.example}
                          </p>
                        )}
                        {item.subLabel && (
                          <p className="text-sm font-normal ellipsis-1-lines">{item.subLabel}</p>
                        )}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        {activeTab === "addfilters" && (
          <div>
            <ul>
              {[
                "Search Title",
                "Job Title",
                "Keywords",
                "Skills",
                "Experience",
                "Industry",
                "Company Size",
                "Years in Current Position",
                "Location",
                "Degree",
                "Fields of Study",
                "Time Zone",
                "Diversity",
                "Volunteering",
                "Languages",
                "Certifications",
                "Groups",
                "Interests",
              ].map((label, index) => (
                <li
                  key={index}
                  className={`py-2.5 px-6 text-text-tertiary font-medium text-sm flex items-center justify-between cursor-pointer ${
                    filterIndex === index
                      ? "bg-utility-bluelight"
                      : "odd:bg-white-100 even:bg-utility-Grayblue"
                  }`}
                  onClick={() => filterItemClick(index)}
                >
                  <Checkbox>
                    {label}
                    {/* {filterIndex === index ? (
                      <IoArrowForwardOutline className="text-primary" />
                    ) : null} */}
                  </Checkbox>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default FiltersSidebar;
